import { ApiService } from './apiService';

export const ServicioService = {
    getAllServicio: async () => {
        try {
          const response =  await ApiService.get('/Servicio');
          return response;
      
        } catch (error) {
            ApiService.handleApiError('Error al obtener los servicios:', error);
          throw error;
        }
    },
    
    getServicioById: async (id) => {
    try {
        const response = await ApiService.get(`/Servicio/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error al obtener el servicio con id ${id}:`, error);
        throw error;
    }
    },

    
    createServicio: async (servicioData) => {
    try {
        const response = await ApiService.post('/Servicio', servicioData);
        return response.data;
    } catch (error) {
        console.error('Error al crear el servicio:', error);
        throw error;
    }
    },
    
    editServicio: async (id, servicioData) => {
    try {
        servicioData.id = id;
        const response = await ApiService.put(`/Servicio/${id}`, servicioData);
        return response.data;
    } catch (error) {
        console.error('Error al editar el servicio:', error);
        throw error;
    }
    },
    
    deleteServicio: async (id) => {
    try {
        const response = await ApiService.delete(`/Servicio/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al desactivar:', error);
        throw error;
    }
    },

}